var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMjnLogoRgbWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MJN_Logo_RGB_White",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 218.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#TOP_SWIRL);\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: url(#BOTTOM_SWIRL);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BOTTOM_SWIRL",
    "data-name": "BOTTOM SWIRL",
    x1: 59.26,
    y1: 162.44,
    x2: 329.08,
    y2: 53.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fbba3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f3a130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e87b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dd5b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cf3426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#c71b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4132a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "TOP_SWIRL",
    "data-name": "TOP SWIRL",
    x1: 185.5,
    y1: 158.54,
    x2: 441.05,
    y2: 59.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fbba3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f3a130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e87b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dd5b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#cf3426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c71b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4132a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.65,158.76l2.81-16.04h3.37l5.37,10.44,1.83-10.44h3.35l-2.81,16.04h-3.37l-5.36-10.58-1.85,10.58h-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.97,159.1c-1.5,0-2.71-.3-3.62-.89-.91-.59-1.54-1.4-1.87-2.43-.34-1.03-.39-2.2-.16-3.51l1.68-9.55h3.45l-1.69,9.65c-.21,1.19-.06,2.08.43,2.67s1.28.88,2.34.88,1.93-.29,2.64-.88,1.16-1.48,1.37-2.67l1.69-9.65h3.46l-1.68,9.55c-.23,1.31-.69,2.48-1.39,3.51s-1.6,1.84-2.72,2.43-2.43.89-3.92.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.22,158.76l2.27-12.94h-4.42l.54-3.1h12.31l-.54,3.1h-4.42l-2.27,12.94h-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.5,158.76l2.81-16.04h6.46c1.18,0,2.17.19,2.99.58.81.39,1.39.94,1.74,1.67.35.72.44,1.59.26,2.6-.14.79-.42,1.49-.84,2.09-.42.6-.95,1.1-1.57,1.5s-1.31.69-2.07.87l3.38,6.74h-4.11l-2.85-6.08h-1.69l-1.07,6.08h-3.44ZM353.49,149.92h2.56c.88,0,1.61-.18,2.17-.53.56-.36.91-.9,1.04-1.62.13-.75,0-1.31-.4-1.68-.4-.37-1.04-.56-1.92-.56h-2.68l-.77,4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.4,158.76l2.81-16.04h3.44l-2.81,16.04h-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.3,158.76l2.27-12.94h-4.42l.54-3.1h12.31l-.54,3.1h-4.42l-2.27,12.94h-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.63,158.76l2.81-16.04h3.44l-2.81,16.04h-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.15,159.1c-1.24,0-2.35-.21-3.33-.64-.98-.42-1.79-1.01-2.44-1.77-.65-.76-1.09-1.64-1.34-2.66s-.27-2.12-.06-3.3c.21-1.19.62-2.29,1.22-3.31s1.36-1.9,2.27-2.66c.91-.76,1.93-1.34,3.06-1.76,1.13-.42,2.31-.63,3.55-.63s2.35.21,3.33.64,1.79,1.02,2.43,1.79,1.1,1.65,1.35,2.66c.26,1.01.28,2.1.08,3.27-.21,1.18-.62,2.29-1.23,3.3-.61,1.02-1.37,1.9-2.29,2.66-.91.76-1.93,1.35-3.05,1.77-1.13.42-2.31.64-3.55.64ZM413.71,155.92c.72,0,1.41-.12,2.07-.37s1.25-.59,1.79-1.05c.54-.45.99-1,1.35-1.63s.61-1.34.75-2.13c.18-1.05.12-1.96-.18-2.73-.31-.78-.8-1.38-1.49-1.8-.69-.43-1.51-.64-2.47-.64-.71,0-1.4.12-2.06.37-.66.25-1.26.59-1.79,1.05-.53.46-.98,1-1.35,1.63-.36.63-.61,1.34-.75,2.13-.18,1.05-.12,1.96.18,2.73s.8,1.38,1.49,1.8c.69.43,1.5.64,2.46.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.62,158.76l2.81-16.04h3.37l5.37,10.44,1.83-10.44h3.35l-2.81,16.04h-3.37l-5.36-10.58-1.85,10.58h-3.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.88,88.37s-4.48,25.36-6.08,34.41c-1.96,11.09-4.52,23.19-21.28,29.69,24.59,0,28.69-15.59,30.71-27.03l6.92-39.16-10.27,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.43,100.9c-10.98,0-18.5,8.71-20.25,18.59-1.45,7.45,1.02,17.7,13.95,17.7,10.15,0,18.31-7.89,20.19-18.22,1.71-9.89-2.66-18.07-13.89-18.07ZM265.98,118.75c-1.49,9.89-4.76,14.1-8.97,14.24-3.74.15-6.16-4.5-4.74-13.72,1.38-8.62,4.66-14.23,9.05-14.38,4.73-.15,5.87,6.11,4.66,13.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.3,100.91c-4.62,0-10.05,3.39-11.6,4.94l3.46-19.57-10.27,2.09-8.5,48.1h9.9l4.6-26.05c1.35-1.47,4.09-3.32,6.66-3.32,4.27,0,4.94,3.47,4.27,7.16l-3.91,22.2h9.87l4.32-24.42c1.32-7.52-1.93-11.14-8.81-11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.03,111c-.78,4.28.23,7.24,5.35,10.84,4.56,3.18,6.36,3.84,5.84,6.65-.28,1.7-2.04,4.35-6.27,4.35s-7.98-4.42-7.98-4.42l-1.06,6.01c3.06,1.99,6.35,2.76,10.23,2.76,5.01,0,13.92-3.02,15.35-11.13,1.18-6.64-3.18-9.51-7.25-12.17-2.73-1.7-5.1-2.95-4.69-5.53.32-1.78,1.8-3.62,5.33-3.62,3.92,0,7.05,3.39,7.05,3.39l1.02-5.77c-3.05-1.04-6.73-1.46-8.38-1.46-9.32,0-13.67,5.24-14.53,10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.25,100.9c-11.02,0-18.5,8.71-20.25,18.59-1.45,7.45.97,17.7,13.91,17.7,10.19,0,18.31-7.89,20.19-18.22,1.75-9.89-2.66-18.07-13.85-18.07ZM402.75,118.75c-1.44,9.89-4.76,14.1-8.97,14.24-3.73.15-6.11-4.5-4.7-13.72,1.34-8.62,4.62-14.23,9.05-14.38,4.69-.15,5.87,6.11,4.62,13.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.99,100.91c-4.62,0-8.41,2.3-11.4,4.74l.98-5.54-10.27,2.09-6.06,34.27h9.9l4.64-26.24c1.22-1.41,3.9-3.05,6.04-3.05,5.53,0,4.76,4.87,4.24,7.75l-3.79,21.54h9.89l4.31-24.42c1.26-7.15-2.5-11.14-8.47-11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.34,100.91c-4.62,0-8.41,2.3-11.4,4.74l1.08-6.13-10.37,2.68-6.06,34.27h9.9l4.64-26.24c1.22-1.41,3.9-3.05,6.04-3.05,5.53,0,4.76,4.87,4.24,7.75l-3.79,21.54h9.89l4.31-24.42c1.26-7.15-2.5-11.14-8.47-11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.38,120.13c-6.8-.03-8.71-7.6-7.95-12.62.09-.52.18-.88.21-1.1h21.29c2.19-12.25-3.82-16.97-12.05-16.97-10.02,0-18.09,8.34-19.81,18.07-1.98,11.22,4.54,18.22,13.42,18.22,7.12,0,13.98-4.33,15.7-10.26,0,0-4.55,4.7-10.82,4.67ZM140.87,93.57c2.91,0,4.7,3.32,3.79,8.56h-11.15c1.03-4.87,3.92-8.56,7.36-8.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.77,89.43c-5.61,0-10.1,1.41-13.03,2.73l-1.08,5.54s5.35-4.13,10.66-4.13c3.09,0,4.38,2.57,3.77,5.98-.15,1.17-.41,2.58-1.52,3.39-2.65,1.91-9.89,2.8-13.85,5.23-3.93,2.22-5.82,5.4-6.3,8.19-.73,3.99,1.21,9.37,7.35,9.37,4.13,0,7.83-1.96,10.43-4.1l-.6,3.39h9.9s3.89-22,4.18-23.62c1.95-11.07-5.98-11.96-9.9-11.96ZM171.86,117.8c-1.26,1.04-3.06,2.04-4.98,2.04-2.48,0-4.36-1.48-3.69-5.1.48-2.8,2.39-4.35,4.92-5.68,2.3-1.04,3.76-1.34,5.69-2.22l-1.94,10.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.12,125.76l10.27-2.09,8.63-48.81-10.27,2.09-2.57,14.55c-1.58-1.11-3.17-2.03-6.05-2.03-9.1,0-18.04,8.34-19.83,18.37-1.94,11.15,3.25,17.92,10.48,17.92,4.05,0,7.79-2.19,10-3.74l-.66,3.74ZM204.27,120.02c-2.75,0-8.18-2.3-6.2-13.5,1-5.77,4.72-12.69,10.55-12.69,2.05,0,3.01,1.2,3.75,2.23l-3.97,22.49c-.91.52-2.52,1.47-4.12,1.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.2 74.83 93.79 110.12 87.55 74.83 76.07 74.83 67.21 124.99 72.71 124.99 79.61 85.94 86.52 124.99 88.32 124.99 92.03 124.99 111.66 85.94 104.76 124.99 114.66 124.99 123.53 74.83 111.2 74.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "455.76 97.69 455.76 98.69 457.69 98.69 457.69 104.01 458.92 104.01 458.92 98.69 460.84 98.69 460.84 97.69 455.76 97.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "467.36 97.7 465.65 102.16 463.92 97.7 462.14 97.7 462.14 104.02 463.29 104.02 463.29 99.09 463.31 99.09 465.19 104.02 466.06 104.02 467.94 99.09 467.97 99.09 467.97 104.02 469.12 104.02 469.12 97.7 467.36 97.7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.62,129.47c-16.64,7.27-80.91,26.54-115.85,24.93-28.21-1.3-42.78-11.36-40.89-26.32-6.45,4.87-10.1,10.69-9.68,16.69,1.02,14.38,20.63,24.63,52.43,23.48,31.05-1.11,74.81-17.13,114.06-38.55.94-.51,1.04-.71-.07-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.28,71.72c-6.76-15.5-36.22-23.7-72.08-21.06-41.14,3.02-88.03,21.24-134.91,47.01-.73.4-.85.65.1.17,17.92-9.04,84.25-36.17,142.42-34.03,28.92,1.06,59.47,12.12,54.16,33.58,7.96-5.98,15.11-14.62,10.3-25.65Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjnLogoRgbWhite);
export default __webpack_public_path__ + "static/media/MJN_logo_RGB_White.a784bbeffd69b0c43910942fb75ba692.svg";
export { ForwardRef as ReactComponent };